import React, { useMemo } from 'react';
import { useApiClient, useFetch } from '@marageti/z4-lib';
import { SalesRecording } from '@marageti/z4-sdk/lib/travel';
import { SearchResult, SearchRequest } from '@marageti/z4-sdk/lib/entity';
import { useParams } from 'react-router-dom';
import SalesView from './sales-view';

const SalesContainer = () => {
  const { tripMatchId } = useParams<{ tripMatchId: string }>();

  const apiClient = useApiClient();

  const searchRequest: SearchRequest = {
    filterBy: [{
      field: 'tripMatchId',
      value: [tripMatchId!],
    },
    ],
    sortBy: [{ field: 'createdAt', order: 'asc' }],
    pagination: { limit: 10000, page: 1 },
  };

  const { data: salesRecordings, isLoading } = useFetch<SearchResult<SalesRecording>>(apiClient.salesRecordingsClient.postSalesRecordingSearch, [searchRequest], !!tripMatchId);

  const totalSales = useMemo(() => {
    if (salesRecordings && salesRecordings.hits.length > 0) {
      const ts = salesRecordings.hits.reduce((total, hit) => hit.price.amount + total, 0);
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: salesRecordings.hits[0].price.currencyCode }).format(ts);
    }
    return undefined;
  }, [salesRecordings]);

  const totalCommission = useMemo(() => {
    if (salesRecordings && salesRecordings.hits.length > 0) {
      const tc = salesRecordings.hits.reduce((total, hit) => hit.commission.amount + total, 0);
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: salesRecordings.hits[0].commission.currencyCode }).format(tc);
    }
    return undefined;
  }, [salesRecordings]);

  return (
    <SalesView
      isLoading={isLoading}
      sales={salesRecordings?.hits}
      totalCommission={totalCommission}
      totalSales={totalSales}
    />
  );
};

export default SalesContainer;
